import { A as emberArray } from '@ember/array';
import { isEmberTesting } from 'ember-simplepractice/utils/is-testing';
import InfinityModel from 'ember-infinity/lib/infinity-model';

export const CONVERSATIONS_PER_PAGE = 30;
export const MESSAGES_PER_PAGE = isEmberTesting() ? 10 : 30;

/**
 * A self-contained `InfinityModel` — no pagination, no backing store call —
 * suitable as a placeholder before a real one has been fetched, or as a
 * pre-seeded stand-in for tests. It exposes the full `MutableArray` surface
 * (so callers can safely call `unshiftObject`, `removeObject`, etc.) and
 * reports `reachedInfinity: true` so `SharedInfinityLoader` doesn't hang on
 * a loading spinner. In production the placeholder is expected to be
 * replaced by a real `InfinityModel` (via `infinity.model(...)`) once data
 * loads; tests may seed initial items and treat it as terminal.
 */
export function emptyInfinityModel(items = []) {
  return InfinityModel.create({
    content: emberArray([...items]),
    reachedInfinity: true,
  });
}

export function pageNumberInfinityModel(perPage = CONVERSATIONS_PER_PAGE) {
  return class ExtendedInfinityModel extends InfinityModel {
    afterInfinityModel(model) {
      this.set('canLoadMore', model.length >= perPage);
    }
  };
}

export function pageNumberInfinityOptions(perPage = CONVERSATIONS_PER_PAGE) {
  return {
    startingPage: 1,
    perPage,
    perPageParam: 'page[size]',
    pageParam: 'page[number]',
  };
}

export function conversationInfinityModel(isClient) {
  return class ConversationInfinityModel extends pageNumberInfinityModel(CONVERSATIONS_PER_PAGE) {
    afterInfinityModel(model) {
      super.afterInfinityModel(model);

      return model.filter(conversation => {
        const { disabled, inactive } = conversation;

        return !disabled && !(isClient && inactive);
      });
    }
  };
}
